// The guide runner (Driver.js and the guide code) is its own esbuild entry, guide_runner.js, built next to
// application.js like chart.js. The page names its fingerprinted URL; a variable specifier keeps esbuild from
// pulling the module into application.js, and it is a function of its own so tests can replace it.
export const loadRunner = (url) => import(/* @vite-ignore */ url)
